import {
  SEND_STATUS,
  SEND_STATUS_SUCCESS
} from "./actionTypes";


const initialState = {
  status: null,
};


const Status = (state = initialState, action) => {

  switch (action.type) {
    case SEND_STATUS:
      state = {
        ...state,
        status: null,
      }
      break;
    case SEND_STATUS_SUCCESS:
      state = {
        ...state,
        status: action.payload.data.status,
      }
      break;
    default: {
      break;
    }
  }
  return state;
}

export default Status;